import React, { useState } from "react";
import { useField } from "formik";
import PlacesAutocomplete from "react-places-autocomplete";
import { styles as textInputStyles } from "./TextField";

const searchOptions = {
  componentRestrictions: { country: "au" },
};

type GoogleAddressProps = {
  className?: string;
  id: string;
  name: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange: (address: string) => void;
  initialValue?: string;
};

function GoogleAddress({
  onChange,
  id,
  name,
  onBlur,
  initialValue = "",
}: GoogleAddressProps) {
  const [address, setAddress] = useState(initialValue);
  const [_, { error, touched }] = useField(name);

  const handleChange = (address: string) => {
    setAddress(address);
    onChange(address);
  };

  const handleSelect = (address: string) => {
    setAddress(address);
    onChange(address);
  };

  return (
    <PlacesAutocomplete
      value={address}
      onChange={handleChange}
      onSelect={handleSelect}
      searchOptions={searchOptions}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <input
            className={textInputStyles({ error, touched })}
            {...getInputProps({
              id,
              onBlur,
            })}
          />

          <div className="address-autocomplete-dropdown-container">
            {loading && <div className="suggestion-item">Loading...</div>}
            {suggestions.map((suggestion) => {
              const className = suggestion.active
                ? "suggestion-item--active"
                : "suggestion-item";
              const style = suggestion.active
                ? { backgroundColor: "#fafafa", cursor: "pointer" }
                : { backgroundColor: "#ffffff", cursor: "pointer" };
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                  })}
                >
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
}

export default GoogleAddress;
